import { useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Row, Col, Container } from 'react-bootstrap';
import BlackLogo from '../images/veeyaa-full-logo.png';

import WhiteLogo from '../images/veeyaa-full-logo-white.png';

import { Link, useLocation } from "react-router-dom";

const ActiveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 100" width="108" height="30" style={{verticalAlign:"text-bottom"}} aria-hidden="true">
    <g>
      <path d="M196.325 57.279a5.405 5.405 0 0 1-8.025.374L180.639 50l-7.652 7.652a10.822 10.822 0 0 1-15.312 0L150.024 50l-7.661 7.652c-4.223 4.231-11.08 4.231-15.312 0L119.399 50l-7.651 7.652a10.822 10.822 0 0 1-15.312 0L88.784 50l-7.652 7.652a10.822 10.822 0 0 1-15.312 0L58.17 50l-7.661 7.652c-4.223 4.231-11.08 4.231-15.312 0L27.545 50l-7.651 7.652a5.416 5.416 0 0 1-7.661 0 5.405 5.405 0 0 1 0-7.652l7.66-7.66c4.223-4.223 11.081-4.223 15.304 0L42.861 50l7.652-7.66c4.232-4.223 11.08-4.223 15.312 0L73.477 50l7.66-7.66c4.223-4.223 11.08-4.223 15.313 0l7.652 7.66 7.652-7.66c4.232-4.223 11.08-4.223 15.312 0l7.652 7.66 7.66-7.66c4.223-4.223 11.08-4.223 15.313 0l7.652 7.66 7.652-7.66c4.232-4.223 11.08-4.223 15.312 0l7.652 7.66 7.66-7.66c4.223-4.223 11.08-4.223" fill="currentColor" />
    </g>
</svg>
);

const Header = () => {
  const location = useLocation();
  const pathname = location && location.pathname ? location.pathname : '/';
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const toggleBodyClass = () => {
      const headerEl = document.getElementById('header');
      if (!headerEl) return;
      if (window.scrollY < 100) {
        headerEl.classList.add('navtop');
        headerEl.classList.remove('navscroll');
      } else {
        headerEl.classList.remove('navtop');
        headerEl.classList.add('navscroll');
      }
    };

    window.addEventListener('scroll', toggleBodyClass);
    toggleBodyClass();
    return () => window.removeEventListener('scroll', toggleBodyClass);
  }, []);

  // Smooth scroll to top on route change
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);

  return (
    <Container>
      <Navbar expanded={expanded} onToggle={() => setExpanded(!expanded)} className="custom-navbar navtop liquidGlass-wrapper" collapseOnSelect expand="xl" id="header">
        <div className="liquidGlass-effect"></div>
        <div className="liquidGlass-tint"></div>
        <div className="liquidGlass-shine"></div>
        <Container fluid>
          <Row className="w-100">
            <Col md={11} className="px-xl-0 pr-0 mx-auto">
              <div className="d-xl-flex align-items-center">
                <div className="">
                  <Navbar.Brand href="#home" className="d-inline-block heading">
                    {/* Veeyaa Innovatives */}
                    <img src={BlackLogo} alt="Veeyaa Innovatives Logo" className="ml-2 black-logo" style={{ verticalAlign: 'middle' }} />
                    <img src={WhiteLogo} alt="Veeyaa Innovatives Logo" className="ml-2 white-logo" style={{ verticalAlign: 'middle' }} />
                   
                    
                  </Navbar.Brand>
                  <button
                    aria-controls="responsive-navbar-nav"
                    aria-expanded={expanded}
                    className="navbar-toggler float-right mt-3"
                    type="button"
                    onClick={() => setExpanded(!expanded)}
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </div>
                <div id="responsive-navbar-nav" className={`collapse navbar-collapse ${expanded ? 'show' : ''}`}>
                  <Nav className="ml-auto">
                    <Link className="nav-link nav-home" to="/" onClick={() => setExpanded(false)}>
                      Home{pathname === '/' ? <ActiveIcon /> : null}
                    </Link>
                    <Link className="nav-link nav-about" to="/about-us" onClick={() => setExpanded(false)}>
                      About Us{pathname === '/about-us' ? <ActiveIcon /> : null}
                    </Link>
                    <Link className="nav-link nav-services" to="/services" onClick={() => setExpanded(false)}>
                      Services{pathname === '/services' ? <ActiveIcon /> : null}
                    </Link>
                    <Link className="nav-link nav-contact" to="/contact-us" onClick={() => setExpanded(false)}>Contact Us{pathname === '/contact-us' ? <ActiveIcon /> : null}
                    </Link>

                    <Link className="nav-link" to="/">
                      <button type="button" className="btn btn-quote" onClick={() => setExpanded(false)}>
                        Get a Quote
                      </button>
                    </Link>

                  </Nav>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

      </Navbar>

      <svg style={{ display: "none" }}>
        <filter
          id="glass-distortion"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.01 0.01"
            numOctaves="1"
            seed="5"
            result="turbulence"
          />

          <feComponentTransfer in="turbulence" result="mapped">
            <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
            <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
            <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
          </feComponentTransfer>

          <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />

          <feSpecularLighting
            in="softMap"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="100"
            lighting-color="white"
            result="specLight"
          >
            <fePointLight x="-200" y="-200" z="300" />
          </feSpecularLighting>

          <feComposite
            in="specLight"
            operator="arithmetic"
            k1="0"
            k2="1"
            k3="1"
            k4="0"
            result="litImage"
          />

          <feDisplacementMap
            in="SourceGraphic"
            in2="softMap"
            scale="150"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </svg>

    </Container>
  );
};

export default Header;
